module.exports = __webpack_public_path__ + "static/media/095.67e70e32.jpg";